import CustomTable from '../shared/CustomTable';
import ItemsListCollapseableTable from '../shared/ItemsListCollapseable';
import { formatDate } from '../utils/FormateDateTime';
import { handlePrintData } from '../utils/PrintData';
import { patientCompanyColumns } from './BeneficiaryConstants';
import XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import { AmiriRegBase64 } from '../assets/fonts/Amiri';
import { AmiriBoldBase64 } from '../assets/fonts/AmiriB';

export const doctorSummaryReportColumns = t => [
  {
    header: t('Department ID'),
    body: row => row.doctor_id,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Department Name'),
    body: row => row.practitioner || '-',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Number of Patient'),
    body: row => row?.total_amount || '-',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Amount'),
    body: row => row?.total_amount || '-',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Credit'),
    body: row => row?.total_credit || '-',
    headerCellClass: '!bg-gray-200'
  }
];

export const docRepColumns = t => [
  {
    header: t('Date'),
    body: row =>
      row.isSummary ? (
        <span className="font-bold text-primary text-[14px]">
          {row.isGrandTotal ? t('GRAND TOTAL') : t('TOTAL')}
        </span>
      ) : (
        formatDate(row?.date)
      ),
    headerCellClass: '!bg-gray-200',
    bodyCellClass: row => (row?.isSummary ? '!bg-gray-100 font-bold' : '')
  },
  {
    header: t('Practioner'),
    body: row =>
      !row?.isSummary ? row.practitioner || '-' : <span className="text-primary font-bold">{row.practitioner || '-'}</span>,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Department'),
    body: row =>
      !row?.isSummary ? row.department || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Patient Name'),
    body: row =>
      !row?.isSummary ? row.patient_name || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('MRN'),
    body: row =>
      !row?.isSummary ? row.file_no || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Cash Invoice'),
    body: row =>
      !row?.isSummary ? (
        row?.cash_invoice_number || '-'
      ) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Insurance Invoice'),
    body: row =>
      !row?.isSummary ? (
        row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number
      ) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Item Code'),
    body: row =>
      !row?.isSummary ? row.item_code || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Payment Method'),
    body: row =>
      !row?.isSummary ? (
        row?.payment_method
      ) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Category'),
    body: row =>
      !row?.isSummary ? (
        row?.payer_category || '-'
      ) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Company Name'),
    body: row =>
      !row?.isSummary ? (
        row?.payer_name || '-'
      ) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Type'),
    body: row =>
      !row?.isSummary ? row?.item_type || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Service'),
    body: row =>
      !row?.isSummary ? row?.item_name || '-' : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Quantity'),
    body: row =>
      !row?.isSummary ? (
        row?.quantity || 0
      ) : (
        ""
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Unit Price'),
    body: row =>
      !row?.isSummary ? Number(row?.unit_price || 0).toFixed(2) : '',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Discount'),
    body: row =>
      !row?.isSummary ? (
        Number(row?.discount_amount || 0).toFixed(2)
      ) : (
        <span className="font-bold text-primary">
          {Number(row?.discount_amount || 0).toFixed(2)}
        </span>
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Patient Share'),
    body: row =>
      !row?.isSummary ? (
        Number(row?.patient_share_amount || 0).toFixed(2)
      ) : (
        <span className="font-bold text-primary">
          {Number(row?.patient_share_amount || 0).toFixed(2)}
        </span>
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Company Share'),
    body: row =>
      !row?.isSummary ? (
        Number(row?.company_share || 0).toFixed(2)
      ) : (
        <span className="font-bold text-primary">
          {Number(row?.company_share || 0).toFixed(2)}
        </span>
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Patient Vat'),
    body: row =>
      !row?.isSummary ? (
        Number(row?.patient_tax_amount || 0).toFixed(2)
      ) : (
        <span className="font-bold text-primary">
          {Number(row?.patient_tax_amount || 0).toFixed(2)}
        </span>
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Company Vat'),
    body: row =>
      !row?.isSummary ? (
        Number(row?.company_tax_amount || 0).toFixed(2)
      ) : (
        <span className="font-bold text-primary">
          {Number(row?.company_tax_amount || 0).toFixed(2)}
        </span>
      ),
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Amount'),
    body: row =>
      row?.isSummary ? (
        <span className="font-bold text-primary px-2 py-1 bg-blue-50  inline-block min-w-[60px] text-center">
          {((row?.patient_share_with_vat || 0) + (row?.company_share_with_vat || 0)).toFixed(2)}
        </span>
      ) : (
        (row?.patient_share_with_vat + row?.company_share_with_vat ||
          row?.net_payable_amount ||
          0).toFixed(2)
      ),
    headerCellClass: '!bg-gray-200'
  }
];

export const docCostRepColumns = (t, data) => {
  const baseColumns = [
    {
      header: t('Date'),
      body: row =>
        row.isSummary ? (
          <span className="font-bold text-primary text-[14px]">
            {row.isGrandTotal ? t('GRAND TOTAL') : t('TOTAL')}
          </span>
        ) : (
          formatDate(row?.date)
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: row => (row?.isSummary ? '!bg-gray-100 font-bold !p-0' : '!p-0')
    },
    {
      header: t('Practioner'),
      body: row =>
        !row?.isSummary ? row.practitioner || '-' : <span className="text-primary font-bold">{row.practitioner || '-'}</span>,
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Department'),
      body: row =>
        !row?.isSummary ? row.department || '-' : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Patient Name'),
      body: row =>
        !row?.isSummary ? row.patient_name || '-' : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('MRN'),
      body: row =>
        !row?.isSummary ? row.file_no || '-' : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Invoice'),
      body: row =>
        !row?.isSummary ? (
          row?.cash_invoice_number || row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number || '-'
        ) : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Item Code'),
      body: row =>
        !row?.isSummary ? row.item_code || '-' : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Item'),
      body: row =>
        !row?.isSummary ? row?.item_name || '-' : '',
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Qty'),
      body: row =>
        !row?.isSummary ? (
          row?.quantity || 0
        ) : (
          ""
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Patient Share'),
      body: row =>
        !row?.isSummary ? (
          Number(row?.patient_share_amount || 0).toFixed(2)
        ) : (
          <span className="font-bold text-primary">
            {Number(row?.patient_share_amount || 0).toFixed(2)}
          </span>
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Company Share'),
      body: row =>
        !row?.isSummary ? (
          Number(row?.company_share || 0).toFixed(2)
        ) : (
          <span className="font-bold text-primary">
            {Number(row?.company_share || 0).toFixed(2)}
          </span>
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Patient Vat'),
      body: row =>
        !row?.isSummary ? (
          Number(row?.patient_tax_amount || 0).toFixed(2)
        ) : (
          <span className="font-bold text-primary">
            {Number(row?.patient_tax_amount || 0).toFixed(2)}
          </span>
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Company Vat'),
      body: row =>
        !row?.isSummary ? (
          Number(row?.company_tax_amount || 0).toFixed(2)
        ) : (
          <span className="font-bold text-primary">
            {Number(row?.company_tax_amount || 0).toFixed(2)}
          </span>
        ),
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    },
    {
      header: t('Total Amount'),
      body: row => {
        const total = (row?.patient_share_with_vat || 0) + (row?.company_share_with_vat || 0);
        return row?.isSummary ? (
          <span className="font-bold text-primary px-2 py-1 bg-blue-50 inline-block min-w-[60px] text-center">
            {total.toFixed(2)}
          </span>
        ) : (
          total.toFixed(2)
        )
      },
      headerCellClass: '!bg-gray-200',
      bodyCellClass: "!p-0"
    }
  ];

  // Dynamic Cost Columns
  const uniqueCosts = Array.from(new Set(
    data?.flatMap(row =>
      row.isSummary
        ? Object.keys(row.cost_breakdown || {})
        : row.manage_costs?.map(c => c.description || c.code) || []
    )
  )).filter(Boolean).sort();

  // Color palette for cost headers
  const costColors = [
    '#FEF3C7', // Amber 100
    '#DCFCE7', // Green 100
    '#DBEAFE', // Blue 100
    '#FCE7F3', // Pink 100
    '#E0E7FF', // Indigo 100
    '#FAE8FF', // Fuchsia 100
    '#F3F4F6', // Gray 100
    '#FFEDD5', // Orange 100
  ];

  const costColumns = uniqueCosts.map((costName, index) => ({
    header: costName,
    body: row => {
      if (row.isSummary) {
        const val = row.cost_breakdown?.[costName] || 0;
        return val ? <span className="font-bold text-primary">{val.toFixed(2)}</span> : '0.00';
      }

      const costItem = row.manage_costs?.find(c => (c.description || c.code) === costName);
      const price = parseFloat(costItem?.price || 0);
      return price ? <span className="font-medium text-gray-700">{price.toFixed(2)}</span> : '0.00';
    },
    headerCellClass: `!bg-opacity-50 border-l border-gray-300`,
    headerStyle: { backgroundColor: costColors[index % costColors.length] },
    bodyCellClass: "!p-0 text-center border-l border-gray-100"
  }));

  // New Columns: Discount and Doctor Total
  const calculatedColumns = [
    {
      header: t('Discount'),
      body: row => {
        const totalInvoice = (row?.patient_share_amount || 0) + (row?.company_share || 0);


        const totalManageCosts = row.isSummary
          ? Object.values(row.cost_breakdown || {}).reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
          : (row.manage_costs || []).reduce((sum, cost) => sum + (parseFloat(cost.price) || 0), 0);

        const discount = totalInvoice - totalManageCosts;

        return row.isSummary ? (
          <span className="font-bold text-primary">
            {discount.toFixed(2)}
          </span>
        ) : (
          discount.toFixed(2)
        );
      },
      headerCellClass: `!bg-opacity-50 border-l border-gray-300`,
      bodyCellClass: "!p-0 text-center border-l border-gray-100"
    },
    {
      header: t('Doctor Total'),
      body: row => {
        const totalInvoice = (row?.patient_share_amount || 0) + (row?.company_share || 0);
        const doctorFee = row.isSummary
          ? (row.cost_breakdown?.['Doctor Fee'] || row.cost_breakdown?.['doctor fee'] || 0)
          : (row.manage_costs || []).find(c =>
            (c.description || c.code || '').toLowerCase().includes('doctor')
          )?.price || 0;

        // Calculate discount
        const totalManageCosts = row.isSummary
          ? Object.values(row.cost_breakdown || {}).reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
          : (row.manage_costs || []).reduce((sum, cost) => sum + (parseFloat(cost.price) || 0), 0);

        const discount = totalInvoice - totalManageCosts; // Can be negative
        const doctorTotal = (parseFloat(doctorFee) || 0) + discount;

        return row.isSummary ? (
          <span className="font-bold text-primary px-2 py-1 inline-block min-w-[60px] text-center">
            {doctorTotal.toFixed(2)}
          </span>
        ) : (
          doctorTotal.toFixed(2)
        );
      },
      headerCellClass: `!bg-opacity-50 border-l border-gray-300`,
      bodyCellClass: "!p-0 text-center border-l border-gray-100"
    }
  ];

  return [
    ...baseColumns,
    ...costColumns,
    ...calculatedColumns
  ];
};

export const transformReportData = data => {
  if (!data || !Array.isArray(data)) return [];

  const grandTotal = {
    isSummary: true,
    isGrandTotal: true,
    practitioner: 'ALL PRACTITIONERS',
    quantity: 0,
    discount_amount: 0,
    patient_share_amount: 0,
    company_share: 0,
    patient_tax_amount: 0,
    company_tax_amount: 0,
    patient_share_with_vat: 0,
    company_share_with_vat: 0,
    total_amount: 0,
    total_manage_cost: 0,
    cost_breakdown: {}
  };

  const transformed = data.flatMap(entry => {
    const detailRows = entry.daily_summary_detail.map(detail => {
      const itemManageCost = detail.manage_costs?.reduce((sum, cost) => sum + (parseFloat(cost.price) || 0), 0) || 0;
      return {
        ...detail,
        isSummary: false,
        total_item_manage_cost: itemManageCost,
        // Preserve all fields from detail
        date: detail.date,
        practitioner: detail.practitioner,
        department: detail.department,
        patient_name: detail.patient_name,
        file_no: detail.file_no,
        cash_invoice_number: detail.cash_invoice_number,
        insurance_invoice_number: detail.insurance_invoice_number,
        corporate_invoice_number: detail.corporate_invoice_number,
        government_invoice_number: detail.government_invoice_number,
        payer_category: detail.payer_category,
        payer_name: detail.payer_name,
        item_type: detail.item_type,
        item_name: detail.item_name,
        item_code: detail.item_code,
        quantity: detail.quantity,
        unit_price: detail.unit_price,
        discount_amount: detail.discount_amount,
        patient_share_amount: detail.patient_share_amount,
        company_share: detail.company_share,
        patient_tax_amount: detail.patient_tax_amount,
        company_tax_amount: detail.company_tax_amount,
        patient_share_with_vat: detail.patient_share_with_vat,
        company_share_with_vat: detail.company_share_with_vat,
        net_payable_amount: detail.net_payable_amount
      }
    });

    // Calculate practitioner-level summary from details
    const practitionerSummary = detailRows.reduce(
      (acc, d) => {
        acc.quantity += parseFloat(d.quantity) || 0;
        acc.discount_amount += parseFloat(d.discount_amount) || 0;
        acc.patient_share_amount += parseFloat(d.patient_share_amount) || 0;
        acc.company_share += parseFloat(d.company_share) || 0;
        acc.patient_tax_amount += parseFloat(d.patient_tax_amount) || 0;
        acc.company_tax_amount += parseFloat(d.company_tax_amount) || 0;
        acc.patient_share_with_vat += parseFloat(d.patient_share_with_vat) || 0;
        acc.company_share_with_vat += parseFloat(d.company_share_with_vat) || 0;
        acc.total_manage_cost += d.total_item_manage_cost || 0;

        // Aggregate cost breakdown for summary
        d.manage_costs?.forEach(cost => {
          const key = cost?.description || cost?.code;
          if (key) {
            acc.cost_breakdown[key] = (acc.cost_breakdown[key] || 0) + (parseFloat(cost.price) || 0);
          }
        });

        return acc;
      },
      {
        quantity: 0,
        discount_amount: 0,
        patient_share_amount: 0,
        company_share: 0,
        patient_tax_amount: 0,
        company_tax_amount: 0,
        patient_share_with_vat: 0,
        company_share_with_vat: 0,
        total_manage_cost: 0,
        cost_breakdown: {}
      }
    );

    const summaryRow = {
      ...practitionerSummary,
      isSummary: true,
      practitioner: entry?.daily_summary?.practitioner || '---',
      // Clear detail-only fields for summary rows
      date: null,
      department: null,
      patient_name: null,
      cash_invoice_number: null,
      insurance_invoice_number: null,
      corporate_invoice_number: null,
      government_invoice_number: null,
      payer_category: null,
      payer_name: null,
      item_type: null,
      item_name: null,
      item_code: null,
      unit_price: null
    };

    ['discount_amount', 'patient_share_amount', 'company_share', 'patient_tax_amount', 'company_tax_amount', 'patient_share_with_vat', 'company_share_with_vat', 'total_manage_cost'].forEach(key => {
      practitionerSummary[key] = Number(practitionerSummary[key].toFixed(2));
    });

    // Update Grand Total with calculated values
    Object.keys(practitionerSummary).forEach(key => {
      if (key === 'cost_breakdown') {
        Object.keys(practitionerSummary.cost_breakdown).forEach(costKey => {
          grandTotal.cost_breakdown[costKey] = (grandTotal.cost_breakdown[costKey] || 0) + practitionerSummary.cost_breakdown[costKey];
        });
      } else {
        grandTotal[key] += practitionerSummary[key];
      }
    });

    return [...detailRows, summaryRow];
  });

  ['discount_amount', 'patient_share_amount', 'company_share', 'patient_tax_amount', 'company_tax_amount', 'patient_share_with_vat', 'company_share_with_vat', 'total_amount', 'total_manage_cost'].forEach(key => {
    grandTotal[key] = Number(grandTotal[key].toFixed(2));
  });

  return [...transformed, grandTotal];
};

export const summaryDocColumns = t => [
  {
    header: t('Practitioner'),
    field: 'practitioner',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Invoices'),
    field: 'invoice_count',
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Discount'),
    body: row => row.total_discount,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Patient Vat'),
    body: row => row.total_tax_amount,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Company Vat'),
    body: row => row.company_share,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Patient Amount'),
    body: row => row.total_patient_amount,
    headerCellClass: '!bg-gray-200'
  },
  {
    header: t('Total Company Amount'),
    body: row => row.total_company_amount,
    headerCellClass: '!bg-gray-200'
  }
];

const itemColumns = [
  {
    header: 'Service',
    field: 'item_name',
    headerCellClass: '!bg-black',
    headerTitleClass: '!text-white'
  },
  {
    header: 'Quantity',
    field: 'quantity',
    headerCellClass: '!bg-black',
    headerTitleClass: '!text-white'
  },
  {
    header: 'Unit Price',
    field: 'unit_price',
    headerCellClass: '!bg-black',
    headerTitleClass: '!text-white'
  },
  {
    header: 'Discount',
    field: 'discount_amount',
    headerCellClass: '!bg-black',
    headerTitleClass: '!text-white'
  },
  {
    header: 'Total Amount',
    body: row => row?.total_amount || row?.net_payable_amount,
    headerCellClass: '!bg-black',
    headerTitleClass: '!text-white'
  }
];
export const rowExpansionDocReportItemTemplate = (data, t) => {
  return <CustomTable columns={itemColumns} data={data?.invoice_details} />;
};
export const rowExpansionDocReportTemplate = (data, t) => {
  return (
    <>
      <ItemsListCollapseableTable
        data={data?.invoices || []}
        columns={patientCompanyColumns(t)}
        dataKey={'unique_id'}
        rowExpansionTemplate={rowExpansionDocReportItemTemplate}
      />
    </>
  );
};

export const hanldeReportAllDocPrint = data => {
  const headers = [
    'Practitioner',
    'Invoices',
    'Total Discount',
    'Total Patient Vat',
    'Total Company Vat',
    'Total Patient Amount',
    'Total Company Amount'
  ];

  const fields = [
    'practitioner',
    'invoice_count',
    'total_discount',
    'total_tax_amount',
    'company_share',
    'total_patient_amount',
    'total_company_amount'
  ];
  const html = `
<table style='width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #ccc;'>
<thead>
<tr>
${headers
      .map(header => `<th style="border: 1px solid #ccc; padding: 4px;" class="text-left bg-gray-200">${header}</th>`)
      .join('')}
</tr>
</thead>
<tbody>
${data?.overall_summary
      .map(
        row => `
    <tr>
      ${fields
            .map(
              field =>
                `<td style="border: 1px solid #ccc; padding: 4px;" class="text-left bg-gray-50">${row[field] ?? '--'}</td>`
            )
            .join('')}
    </tr>
  `
      )
      .join('')}
</tbody>
</table>
`;

  handlePrintData(html, 'Items Report');
};
export const handleReportDocprint = data => {
  const headers = [
    'Practitioner',
    'Invoices',
    'Total Discount',
    'Total Patient Vat',
    'Total Company Vat',
    'Total Patient Amount',
    'Total Company Amount'
  ];

  const fields = [
    'practitioner',
    'invoice_count',
    'total_discount',
    'total_tax_amount',
    'company_share',
    'total_patient_amount',
    'total_company_amount'
  ];
  const html = `
<table style='width: 100%; border-collapse: collapse; font-size: 10px; border: 1px solid #ccc;'>
<thead>
<tr>
${headers
      .map(header => `<th style="border: 1px solid #ccc; padding: 4px;" class="text-left bg-gray-200">${header}</th>`)
      .join('')}
</tr>
</thead>
<tbody>
${data?.overall_summary
      .map(
        row => `
    <tr>
      ${fields
            .map(
              field =>
                `<td style="border: 1px solid #ccc; padding: 4px;" class="text-left bg-gray-50">${row[field] ?? '--'}</td>`
            )
            .join('')}
    </tr>
  `
      )
      .join('')}
</tbody>
</table>
`;

  handlePrintData(html, 'Doctor Report Summary');
};

export const exportDocRepToExcel = (
  data,
  t,
  fileName = 'doctor-daily-report.xlsx'
) => {
  const formatted = data?.map(row => {
    const isSummary = row?.isSummary;
    const isGrandTotal = row?.isGrandTotal;

    let dateLabel = '-';
    if (isGrandTotal) dateLabel = t('GRAND TOTAL');
    else if (isSummary) dateLabel = t('TOTAL');
    else dateLabel = row?.date ? formatDate(row.date) : '-';

    return {
      [t('Date')]: dateLabel,
      [t('Practioner')]: isGrandTotal
        ? t('ALL PRACTITIONERS')
        : row?.practitioner || '-',
      [t('Department')]: !isSummary ? row?.department || '-' : '',
      [t('Patient Name')]: !isSummary ? row?.patient_name || '-' : '',
      [t('MRN')]: !isSummary ? row?.file_no || '-' : '',
      [t('Cash Invoice')]: !isSummary ? row?.cash_invoice_number || '-' : '',
      [t('Insurance Invoice')]: !isSummary
        ? row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number || '-'
        : '',
      [t('Payment Method')]: !isSummary ? row?.payment_method || '-' : '',
      [t('Category')]: !isSummary ? row?.payer_category || '-' : '',
      [t('Company Name')]: !isSummary ? row?.payer_name || '-' : '',
      [t('Item Code')]: !isSummary ? row?.item_code || '-' : '',
      [t('Type')]: !isSummary ? row?.item_type || '-' : '',
      [t('Service')]: !isSummary ? row?.item_name || '-' : '',
      [t('Quantity')]: row?.quantity ?? 0,
      [t('Unit Price')]: !isSummary ? Number(row?.unit_price || 0).toFixed(2) : '',
      [t('Discount')]: Number(row?.discount_amount || 0).toFixed(2),
      [t('Patient Share')]: Number(row?.patient_share_amount || 0).toFixed(2),
      [t('Company Share')]: Number(row?.company_share || 0).toFixed(2),
      [t('Patient Vat')]: Number(row?.patient_tax_amount || 0).toFixed(2),
      [t('Company Vat')]: Number(row?.company_tax_amount || 0).toFixed(2),
      [t('Total Amount')]:
        ((row?.patient_share_with_vat || 0) + (row?.company_share_with_vat || 0)).toFixed(2)
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(formatted);
  const range = XLSX.utils.decode_range(worksheet['!ref']);

  // Styling constants
  const headerStyle = {
    fill: { fgColor: { rgb: '0F172A' } }, // Midnight Dark
    font: { color: { rgb: 'FFFFFF' }, bold: true, sz: 12 },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } }
    }
  };

  const summaryStyle = {
    fill: { fgColor: { rgb: 'F1F5F9' } }, // Slate 100 - Light Gray
    font: { bold: true, color: { rgb: '334155' }, sz: 10, name: 'Calibri' }, // Slate 700 Text
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: 'CBD5E1' } },
      bottom: { style: 'double', color: { rgb: '64748B' } },
      left: { style: 'thin', color: { rgb: 'CBD5E1' } },
      right: { style: 'thin', color: { rgb: 'CBD5E1' } }
    }
  };

  const grandTotalStyle = {
    fill: { fgColor: { rgb: '94A3B8' } }, // Slate 400 - Medium Gray Highlight
    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'double', color: { rgb: '475569' } },
      bottom: { style: 'double', color: { rgb: '475569' } },
      left: { style: 'medium', color: { rgb: '475569' } },
      right: { style: 'medium', color: { rgb: '475569' } }
    }
  };

  const zebraStyle = {
    fill: { fgColor: { rgb: 'F1F5F9' } }, // Slate 100
    alignment: { horizontal: 'center', vertical: 'center' }
  };

  const defaultStyle = {
    alignment: { horizontal: 'center', vertical: 'center' }
  };

  for (let C = range.s.c; C <= range.e.c; ++C) {
    const headerAddress = XLSX.utils.encode_col(C) + '1';
    if (worksheet[headerAddress]) {
      worksheet[headerAddress].s = headerStyle;
    }

    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      if (!worksheet[cellAddress]) continue;

      const rowData = data[R - 1]; // Offset by 1 for header
      if (rowData?.isGrandTotal) {
        worksheet[cellAddress].s = grandTotalStyle;
      } else if (rowData?.isSummary) {
        worksheet[cellAddress].s = summaryStyle;
      } else {
        // Apply Zebra striping to every second data row
        worksheet[cellAddress].s = R % 2 === 0 ? zebraStyle : defaultStyle;
      }
    }
  }

  // Adjust column width
  worksheet['!cols'] = new Array(Object.keys(formatted[0] || {}).length).fill({
    wch: 18
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Doctor Report');
  XLSX.writeFile(workbook, fileName);
};

export const exportDocCostRepToExcel = (
  data,
  t,
  fileName = 'doctor-cost-management-report.xlsx'
) => {
  // Identify all unique cost names for dynamic columns
  const uniqueCosts = Array.from(new Set(
    data?.flatMap(row =>
      row.isSummary
        ? Object.keys(row.cost_breakdown || {})
        : row.manage_costs?.map(c => c.description || c.code) || []
    )
  )).filter(Boolean).sort();

  const formatted = data?.map(row => {
    const isSummary = row?.isSummary;
    const isGrandTotal = row?.isGrandTotal;

    let dateLabel = '-';
    if (isGrandTotal) dateLabel = t('GRAND TOTAL');
    else if (isSummary) dateLabel = t('TOTAL');
    else dateLabel = row?.date ? formatDate(row.date) : '-';

    const totalAmount = (parseFloat(row?.patient_share_with_vat) || 0) + (parseFloat(row?.company_share_with_vat) || 0);

    const rowObj = {
      [t('Date')]: dateLabel,
      [t('Practioner')]: isGrandTotal
        ? t('ALL PRACTITIONERS')
        : row?.practitioner || '-',
      [t('Department')]: !isSummary ? row?.department || '-' : '',
      [t('Patient Name')]: !isSummary ? row?.patient_name || '-' : '',
      [t('MRN')]: !isSummary ? row?.file_no || '-' : '',
      [t('Invoice')]: !isSummary ? (
        row?.cash_invoice_number || row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number || '-'
      ) : '',
      [t('Item Code')]: !isSummary ? row?.item_code || '-' : '',
      [t('Item')]: !isSummary ? row?.item_name || '-' : '',
      [t('Qty')]: !isSummary ? row?.quantity || 0 : '',
      [t('Patient Share')]: row?.patient_share_amount?.toFixed(2) || 0,
      [t('Company Share')]: row?.company_share?.toFixed(2) || 0,
      [t('Patient Vat')]: row?.patient_tax_amount?.toFixed(2) || 0,
      [t('Company Vat')]: row?.company_tax_amount?.toFixed(2) || 0,
      [t('Total Amount')]: totalAmount.toFixed(2),
    };

    // Add dynamic cost columns to the row object
    uniqueCosts.forEach(costName => {
      let costValue = 0;
      if (isSummary) {
        costValue = row.cost_breakdown?.[costName] || 0;
      } else {
        const costItem = row.manage_costs?.find(c => (c.description || c.code) === costName);
        costValue = parseFloat(costItem?.price || 0);
      }
      rowObj[costName] = costValue !== 0 ? costValue.toFixed(2) : '0.00';
    });

    // Add Discount column
    const totalInvoiceWithoutVat = (parseFloat(row?.patient_share_amount) || 0) + (parseFloat(row?.company_share) || 0);
    const totalManageCosts = isSummary
      ? Object.values(row.cost_breakdown || {}).reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
      : (row.manage_costs || []).reduce((sum, cost) => sum + (parseFloat(cost.price) || 0), 0);
    const discount = totalInvoiceWithoutVat - totalManageCosts; // Can be negative
    rowObj[t('Discount')] = discount.toFixed(2);

    // Add Doctor Total column
    const doctorFee = isSummary
      ? (row.cost_breakdown?.['Doctor Fee'] || row.cost_breakdown?.['doctor fee'] || 0)
      : (row.manage_costs || []).find(c =>
        (c.description || c.code || '')?.toLowerCase().includes('doctor')
      )?.price || 0;
    const doctorTotal = (parseFloat(doctorFee) || 0) + discount;
    rowObj[t('Doctor Total')] = doctorTotal.toFixed(2);

    return rowObj;
  });

  const worksheet = XLSX.utils.json_to_sheet(formatted);
  const range = XLSX.utils.decode_range(worksheet['!ref']);

  const headerStyle = {
    fill: { fgColor: { rgb: '475569' } }, // Slate 600
    font: { color: { rgb: 'FFFFFF' }, bold: true, sz: 11, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'medium', color: { rgb: '334155' } },
      bottom: { style: 'medium', color: { rgb: '334155' } },
      left: { style: 'thin', color: { rgb: '64748B' } },
      right: { style: 'thin', color: { rgb: '64748B' } }
    }
  };

  const costHeaderColors = [
    'FEF3C7', // Amber 100
    'DCFCE7', // Green 100
    'DBEAFE', // Blue 100
    'FCE7F3', // Pink 100
    'E0E7FF', // Indigo 100
    'FAE8FF', // Fuchsia 100
    'F3F4F6', // Gray 100
    'FFEDD5', // Orange 100
  ];

  const summaryStyle = {
    fill: { fgColor: { rgb: 'F1F5F9' } }, // Slate 100 - Light Gray
    font: { bold: true, color: { rgb: '334155' }, sz: 10, name: 'Calibri' }, // Slate 700 Text
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: 'CBD5E1' } },
      bottom: { style: 'double', color: { rgb: '64748B' } },
      left: { style: 'thin', color: { rgb: 'CBD5E1' } },
      right: { style: 'thin', color: { rgb: 'CBD5E1' } }
    }
  };

  const grandTotalStyle = {
    fill: { fgColor: { rgb: '94A3B8' } }, // Slate 400 - Medium Gray Highlight
    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'double', color: { rgb: '475569' } },
      bottom: { style: 'double', color: { rgb: '475569' } },
      left: { style: 'medium', color: { rgb: '475569' } },
      right: { style: 'medium', color: { rgb: '475569' } }
    }
  };

  const evenRowStyle = {
    fill: { fgColor: { rgb: 'F8FAFC' } }, // Slate 50
    font: { sz: 10, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: 'E2E8F0' } },
      bottom: { style: 'thin', color: { rgb: 'E2E8F0' } },
      left: { style: 'thin', color: { rgb: 'E2E8F0' } },
      right: { style: 'thin', color: { rgb: 'E2E8F0' } }
    }
  };

  const oddRowStyle = {
    fill: { fgColor: { rgb: 'FFFFFF' } }, // White
    font: { sz: 10, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: 'E2E8F0' } },
      bottom: { style: 'thin', color: { rgb: 'E2E8F0' } },
      left: { style: 'thin', color: { rgb: 'E2E8F0' } },
      right: { style: 'thin', color: { rgb: 'E2E8F0' } }
    }
  };

  // Get headers to identify cost column indices
  const headers = Object.keys(formatted[0] || {});
  const discountColIndex = headers.indexOf(t('Discount'));
  const doctorTotalColIndex = headers.indexOf(t('Doctor Total'));

  // Special styles for Discount and Doctor Total columns
  const discountHeaderStyle = {
    fill: { fgColor: { rgb: 'FEF3C7' } }, // Yellow 100 - Amber
    font: { color: { rgb: '92400E' }, bold: true, sz: 11, name: 'Calibri' }, // Amber 900
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'medium', color: { rgb: 'F59E0B' } }, // Amber 500
      bottom: { style: 'medium', color: { rgb: 'F59E0B' } },
      left: { style: 'medium', color: { rgb: 'F59E0B' } },
      right: { style: 'medium', color: { rgb: 'F59E0B' } }
    }
  };

  const doctorTotalHeaderStyle = {
    fill: { fgColor: { rgb: 'D1FAE5' } }, // Green 100
    font: { color: { rgb: '065F46' }, bold: true, sz: 11, name: 'Calibri' }, // Green 900
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'medium', color: { rgb: '10B981' } }, // Green 500
      bottom: { style: 'medium', color: { rgb: '10B981' } },
      left: { style: 'medium', color: { rgb: '10B981' } },
      right: { style: 'medium', color: { rgb: '10B981' } }
    }
  };

  const discountCellStyle = {
    fill: { fgColor: { rgb: 'FFFBEB' } }, // Amber 50
    font: { sz: 10, name: 'Calibri', color: { rgb: '92400E' } }, // Amber 900
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: 'FCD34D' } }, // Amber 300
      bottom: { style: 'thin', color: { rgb: 'FCD34D' } },
      left: { style: 'thin', color: { rgb: 'FCD34D' } },
      right: { style: 'thin', color: { rgb: 'FCD34D' } }
    }
  };

  const doctorTotalCellStyle = {
    fill: { fgColor: { rgb: 'ECFDF5' } }, // Green 50
    font: { sz: 10, name: 'Calibri', color: { rgb: '065F46' } }, // Green 900
    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
    border: {
      top: { style: 'thin', color: { rgb: '6EE7B7' } }, // Green 300
      bottom: { style: 'thin', color: { rgb: '6EE7B7' } },
      left: { style: 'thin', color: { rgb: '6EE7B7' } },
      right: { style: 'thin', color: { rgb: '6EE7B7' } }
    }
  };

  const discountSummaryStyle = {
    fill: { fgColor: { rgb: 'FEF3C7' } }, // Yellow 100
    font: { bold: true, color: { rgb: '78350F' }, sz: 10, name: 'Calibri' }, // Amber 950
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: 'F59E0B' } },
      bottom: { style: 'double', color: { rgb: 'D97706' } }, // Amber 600
      left: { style: 'thin', color: { rgb: 'F59E0B' } },
      right: { style: 'thin', color: { rgb: 'F59E0B' } }
    }
  };

  const doctorTotalSummaryStyle = {
    fill: { fgColor: { rgb: 'D1FAE5' } }, // Green 100
    font: { bold: true, color: { rgb: '064E3B' }, sz: 10, name: 'Calibri' }, // Green 950
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'thin', color: { rgb: '10B981' } },
      bottom: { style: 'double', color: { rgb: '059669' } }, // Green 600
      left: { style: 'thin', color: { rgb: '10B981' } },
      right: { style: 'thin', color: { rgb: '10B981' } }
    }
  };

  const discountGrandTotalStyle = {
    fill: { fgColor: { rgb: 'FBBF24' } }, // Amber 400
    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'double', color: { rgb: '92400E' } },
      bottom: { style: 'double', color: { rgb: '92400E' } },
      left: { style: 'medium', color: { rgb: '92400E' } },
      right: { style: 'medium', color: { rgb: '92400E' } }
    }
  };

  const doctorTotalGrandTotalStyle = {
    fill: { fgColor: { rgb: '34D399' } }, // Green 400
    font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11, name: 'Calibri' },
    alignment: { horizontal: 'center', vertical: 'center' },
    border: {
      top: { style: 'double', color: { rgb: '065F46' } },
      bottom: { style: 'double', color: { rgb: '065F46' } },
      left: { style: 'medium', color: { rgb: '065F46' } },
      right: { style: 'medium', color: { rgb: '065F46' } }
    }
  };

  // Apply header styles
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const headerAddress = XLSX.utils.encode_col(C) + '1';
    if (worksheet[headerAddress]) {
      const headerText = worksheet[headerAddress].v;
      const costIndex = uniqueCosts.indexOf(headerText);

      if (C === discountColIndex) {
        // Apply Discount header style
        worksheet[headerAddress].s = discountHeaderStyle;
      } else if (C === doctorTotalColIndex) {
        // Apply Doctor Total header style
        worksheet[headerAddress].s = doctorTotalHeaderStyle;
      } else if (costIndex !== -1) {
        // Apply specific color for cost header
        worksheet[headerAddress].s = {
          ...headerStyle
        };
      } else {
        worksheet[headerAddress].s = headerStyle;
      }
    }
  }

  // Apply row styles
  for (let R = range.s.r + 1; R <= range.e.r; ++R) {
    const rowData = data[R - 1];

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      if (!worksheet[cellAddress]) continue;

      // Special styling for Discount and Doctor Total columns
      if (C === discountColIndex) {
        if (rowData?.isGrandTotal) {
          worksheet[cellAddress].s = discountGrandTotalStyle;
        } else if (rowData?.isSummary) {
          worksheet[cellAddress].s = discountSummaryStyle;
        } else {
          worksheet[cellAddress].s = discountCellStyle;
        }
      } else if (C === doctorTotalColIndex) {
        if (rowData?.isGrandTotal) {
          worksheet[cellAddress].s = doctorTotalGrandTotalStyle;
        } else if (rowData?.isSummary) {
          worksheet[cellAddress].s = doctorTotalSummaryStyle;
        } else {
          worksheet[cellAddress].s = doctorTotalCellStyle;
        }
      } else {
        // Apply standard styles for other columns
        if (rowData?.isGrandTotal) {
          worksheet[cellAddress].s = grandTotalStyle;
        } else if (rowData?.isSummary) {
          worksheet[cellAddress].s = summaryStyle;
        } else {
          worksheet[cellAddress].s = R % 2 === 0 ? evenRowStyle : oddRowStyle;
        }
      }
    }
  }

  // Set column widths
  const baseColumnWidths = [
    { wch: 12 },  // Date
    { wch: 20 },  // Practitioner
    { wch: 18 },  // Department
    { wch: 22 },  // Patient Name
    { wch: 15 },  // File No
    { wch: 15 },  // Invoice
    { wch: 15 },  // Item Code
    { wch: 25 },  // Item
    { wch: 8 },   // Qty
    { wch: 14 },  // Patient Share
    { wch: 14 },  // Company Share
    { wch: 12 },  // Patient Vat
    { wch: 12 },  // Company Vat
    { wch: 14 },  // Total Amount
  ];

  // Add widths for dynamic cost columns
  const costColumnWidths = uniqueCosts.map(() => ({ wch: 15 }));

  // Add widths for Discount and Doctor Total columns
  const calculatedColumnWidths = [
    { wch: 14 },  // Discount
    { wch: 14 },  // Doctor Total
  ];

  worksheet['!cols'] = [...baseColumnWidths, ...costColumnWidths, ...calculatedColumnWidths];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Doctor Cost Report');
  XLSX.writeFile(workbook, fileName);
};

// PDF Export for Doctor Daily Report
export const exportDocRepToPDF = (
  data,
  t,
  payloadData,
  fileName = 'doctor-daily-report.pdf'
) => {
  const doc = new jsPDF('landscape');

  // Add Arabic font
  doc.addFileToVFS('Amiri-Regular.ttf', AmiriRegBase64);
  doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
  doc.addFileToVFS('Amiri-Bold.ttf', AmiriBoldBase64);
  doc.addFont('Amiri-Bold.ttf', 'Amiri', 'bold');
  doc.setFont('Amiri', 'normal');

  const lineHeight = 4;
  const start_date = moment(payloadData?.start_date).format('DD/MM/YYYY');
  const end_date = moment(payloadData?.end_date).format('DD/MM/YYYY');
  const pageWidth = doc.internal.pageSize.getWidth();

  const currentDate = moment().format('DD/MM/YYYY');
  const periodText = `Period: ${start_date || '-'} to ${end_date || '-'}`;

  const reportTitle = t('Doctor Daily Report');
  const orgName = payloadData?.business_en || payloadData?.business_ar || 'Organization';
  const location = payloadData?.address || 'Location';

  let y = 10;

  // Header with Logo
  if (payloadData?.logo) {
    try {
      doc.addImage(payloadData.logo, 'PNG', 10, 8, 25, 25);
    } catch (e) {
      console.warn("Could not add logo", e);
    }
  }

  const leftMargin = payloadData?.logo ? 40 : 14;

  // Organization Name
  doc.setFont('Amiri', 'bold');
  doc.setFontSize(12);
  doc.text(orgName, leftMargin, y + 5);

  // Location
  doc.setFont('Amiri', 'normal');
  doc.setFontSize(10);
  doc.text(location, leftMargin, y + lineHeight + 5);

  // Report Title (Right Aligned)
  doc.setFontSize(14);
  doc.setFont('Amiri', 'bold');
  doc.text(reportTitle, pageWidth - 14, y + 5, { align: 'right' });

  // Printed On / Period (Right Aligned under title)
  doc.setFontSize(10);
  doc.setFont('Amiri', 'normal');
  doc.text(periodText, pageWidth - 14, y + lineHeight + 10, { align: 'right' });
  doc.text(`Printed: ${currentDate}`, pageWidth - 14, y + lineHeight + 15, { align: 'right' });

  y += 25; // Adjusted Y for content start

  y += 2;
  doc.setDrawColor(71, 85, 105);
  doc.setLineWidth(0.5);
  doc.line(14, y, pageWidth - 14, y);

  const tableHeaders = [
    t('Date'),
    t('Practioner'),
    t('Dept'),
    t('Patient'),
    t('MRN'),
    t('Cash Inv'),
    t('Ins Inv'),
    t('Item Code'),
    t('Payment'),
    t('Category'),
    t('Payer'),
    t('Type'),
    t('Service'),
    t('Qty'),
    t('Price'),
    t('Disc'),
    t('Pat Share'),
    t('Co Share'),
    t('Pat VAT'),
    t('Co VAT'),
    t('Total'),
  ];

  const tableData = data.map(row => {
    const isSummary = row?.isSummary;
    const isGrandTotal = row?.isGrandTotal;

    let dateLabel = '-';
    if (isGrandTotal) dateLabel = t('GRAND TOTAL');
    else if (isSummary) dateLabel = t('TOTAL');
    else dateLabel = row?.date ? formatDate(row.date) : '-';

    // Attach flags to the row array itself for robust styling identification
    const rowData = [
      dateLabel,
      isGrandTotal ? t('ALL') : row?.practitioner || '-',
      !isSummary ? row?.department || '-' : '',
      !isSummary ? row?.patient_name || '-' : '',
      !isSummary ? row?.file_no || '-' : '',
      !isSummary ? row?.cash_invoice_number || '-' : '',
      !isSummary ? row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number || '-' : '',
      !isSummary ? row?.item_code || '-' : '',
      !isSummary ? row?.payment_method || '-' : '',
      !isSummary ? row?.payer_category || '-' : '',
      !isSummary ? row?.payer_name || '-' : '',
      !isSummary ? row?.item_type || '-' : '',
      !isSummary ? row?.item_name || '-' : '',
      row?.quantity ?? 0,
      !isSummary ? (row?.unit_price ?? 0) : '',
      (row?.discount_amount ?? 0).toFixed(2),
      (row?.patient_share_amount ?? 0).toFixed(2),
      (row?.company_share ?? 0).toFixed(2),
      (row?.patient_tax_amount ?? 0).toFixed(2),
      (row?.company_tax_amount ?? 0).toFixed(2),
      ((row?.patient_share_with_vat || 0) + (row?.company_share_with_vat || 0)).toFixed(2),
    ];

    rowData.isSummary = isSummary;
    rowData.isGrandTotal = isGrandTotal;

    return rowData;
  });

  autoTable(doc, {
    startY: y + 5,
    head: [tableHeaders],
    body: tableData,
    theme: 'grid',
    styles: {
      font: 'Amiri',
      fontSize: 6.5,
      cellPadding: 1.5,
      overflow: 'linebreak',
      halign: 'center',
      valign: 'middle',
    },
    headStyles: {
      fillColor: [71, 85, 105], // Slate 600 - Consistent
      textColor: 255,
      fontStyle: 'bold',
      fontSize: 7,
      halign: 'center',
    },
    // Removing fixed column widths to allow full width expansion
    columnStyles: {
      12: { halign: 'center' }, // Price
      13: { halign: 'center' }, // Disc
      18: { fontStyle: 'bold' }, // Total
    },
    didParseCell: hookData => {
      if (hookData.section === 'body') {
        const rowFlags = hookData.row.raw; // This is the array we returned in map()

        if (rowFlags.isGrandTotal) {
          hookData.cell.styles.fillColor = [100, 116, 139]; // Slate 500
          hookData.cell.styles.textColor = 255; // White
          hookData.cell.styles.fontStyle = 'bold';
          hookData.cell.styles.fontSize = 7;
        } else if (rowFlags.isSummary) {
          hookData.cell.styles.fillColor = [220, 225, 230]; // Clean gray highlight
          hookData.cell.styles.textColor = [30, 41, 59]; // Slate 800
          hookData.cell.styles.fontStyle = 'bold';
          hookData.cell.styles.fontSize = 6.5;
        } else if (hookData.row.index % 2 === 0) {
          hookData.cell.styles.fillColor = [248, 250, 252]; // Slate 50
        }
      }
    },
    margin: { left: 10, right: 10 },
  });

  doc.save(fileName);
};

// PDF Export for Doctor Cost Management Report
export const exportDocCostRepToPDF = (
  data,
  t,
  payloadData,
  fileName = 'doctor-cost-management-report.pdf'
) => {
  const doc = new jsPDF('landscape');

  // Add Arabic font
  doc.addFileToVFS('Amiri-Regular.ttf', AmiriRegBase64);
  doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
  doc.addFileToVFS('Amiri-Bold.ttf', AmiriBoldBase64);
  doc.addFont('Amiri-Bold.ttf', 'Amiri', 'bold');
  doc.setFont('Amiri', 'normal');

  const lineHeight = 4;
  const start_date = moment(payloadData?.start_date).format('DD/MM/YYYY');
  const end_date = moment(payloadData?.end_date).format('DD/MM/YYYY');
  const pageWidth = doc.internal.pageSize.getWidth();

  const currentDate = moment().format('DD/MM/YYYY');
  const periodText = `Period: ${start_date || '-'} to ${end_date || '-'}`;

  const reportTitle = t('Doctor Wise Cost Report');
  const orgName = payloadData?.business_en || payloadData?.business_ar || 'Organization';
  const location = payloadData?.address || 'Location';

  let y = 10;

  // Header with Logo
  if (payloadData?.logo) {
    try {
      doc.addImage(payloadData.logo, 'PNG', 10, 8, 25, 25);
    } catch (e) {
      console.warn("Could not add logo", e);
    }
  }

  const leftMargin = payloadData?.logo ? 40 : 14;

  // Organization Name
  doc.setFont('Amiri', 'bold');
  doc.setFontSize(12);
  doc.text(orgName, leftMargin, y + 5);

  // Location
  doc.setFont('Amiri', 'normal');
  doc.setFontSize(10);
  doc.text(location, leftMargin, y + lineHeight + 5);

  // Report Title (Right Aligned)
  doc.setFontSize(14);
  doc.setFont('Amiri', 'bold');
  doc.text(reportTitle, pageWidth - 14, y + 5, { align: 'right' });

  // Printed On / Period (Right Aligned under title)
  doc.setFontSize(10);
  doc.setFont('Amiri', 'normal');
  doc.text(periodText, pageWidth - 14, y + lineHeight + 10, { align: 'right' });
  doc.text(`Printed: ${currentDate}`, pageWidth - 14, y + lineHeight + 15, { align: 'right' });

  y += 25; // Adjusted Y for content start

  y += 2;
  doc.setDrawColor(71, 85, 105);
  doc.setLineWidth(0.5);
  doc.line(14, y, pageWidth - 14, y);

  // Identify all unique cost names for dynamic columns
  const uniqueCosts = Array.from(new Set(
    data?.flatMap(row =>
      row.isSummary
        ? Object.keys(row.cost_breakdown || {})
        : row.manage_costs?.map(c => c.description || c.code) || []
    )
  )).filter(Boolean).sort();

  const baseHeaders = [
    t('Date'),
    t('Practioner'),
    t('Dept'),
    t('Patient'),
    t('MRN'),
    t('Invoice'),
    t('Item Code'),
    t('Item'),
    t('Qty'),
    t('Pat Share'),
    t('Co Share'),
    t('Pat VAT'),
    t('Co VAT'),
    t('Total'),
  ];

  const tableHeaders = [...baseHeaders, ...uniqueCosts, t('Discount'), t('Doctor Total')];

  const tableData = data.map(row => {
    const isSummary = row?.isSummary;
    const isGrandTotal = row?.isGrandTotal;

    let dateLabel = '-';
    if (isGrandTotal) dateLabel = t('GRAND TOTAL');
    else if (isSummary) dateLabel = t('TOTAL');
    else dateLabel = row?.date ? formatDate(row.date) : '-';

    const totalAmount = (parseFloat(row?.patient_share_with_vat) || 0) + (parseFloat(row?.company_share_with_vat) || 0);

    const rowData = [
      dateLabel,
      isGrandTotal ? t('ALL') : row?.practitioner || '-',
      !isSummary ? row?.department || '-' : '',
      !isSummary ? row?.patient_name || '-' : '',
      !isSummary ? row?.file_no || '-' : '',
      !isSummary ? (row?.cash_invoice_number || row?.insurance_invoice_number || row?.corporate_invoice_number || row?.government_invoice_number || '-') : '',
      !isSummary ? row?.item_code || '-' : '',
      !isSummary ? row?.item_name || '-' : '',
      !isSummary ? (row?.quantity || 0) : '',
      (row?.patient_share_amount ?? 0).toFixed(2),
      (row?.company_share ?? 0).toFixed(2),
      (row?.patient_tax_amount ?? 0).toFixed(2),
      (row?.company_tax_amount ?? 0).toFixed(2),
      totalAmount.toFixed(2),
    ];

    // Append dynamic cost values
    uniqueCosts.forEach(costName => {
      let costValue = 0;
      if (isSummary) {
        costValue = row.cost_breakdown?.[costName] || 0;
      } else {
        const costItem = row.manage_costs?.find(c => (c.description || c.code) === costName);
        costValue = parseFloat(costItem?.price || 0);
      }
      rowData.push(costValue !== 0 ? costValue.toFixed(2) : '0.00');
    });

    const totalManageCosts = isSummary
      ? Object.values(row.cost_breakdown || {}).reduce((sum, val) => sum + (parseFloat(val) || 0), 0)
      : (row.manage_costs || []).reduce((sum, cost) => sum + (parseFloat(cost.price) || 0), 0);
    // Use patient_share_amount + company_share (no VAT) — same base as the table
    const totalInvoiceWithoutVat = (parseFloat(row?.patient_share_amount) || 0) + (parseFloat(row?.company_share) || 0);
    const discount = totalInvoiceWithoutVat - totalManageCosts;
    rowData.push(discount.toFixed(2));

    const doctorFee = isSummary
      ? (row.cost_breakdown?.['Doctor Fee'] || row.cost_breakdown?.['doctor fee'] || 0)
      : (row.manage_costs || []).find(c =>
        (c.description || c.code || '')?.toLowerCase().includes('doctor')
      )?.price || 0;
    const doctorTotal = (parseFloat(doctorFee) || 0) + discount;
    rowData.push(doctorTotal.toFixed(2));

    // Attach flags to the row array itself for robust styling identification
    rowData.isSummary = isSummary;
    rowData.isGrandTotal = isGrandTotal;

    return rowData;
  });

  autoTable(doc, {
    startY: y + 5,
    head: [tableHeaders],
    body: tableData,
    theme: 'grid',
    styles: {
      font: 'Amiri',
      fontSize: 6.5,
      cellPadding: 1.5,
      overflow: 'linebreak',
      halign: 'center',
      valign: 'middle',
    },
    headStyles: {
      fillColor: [71, 85, 105], // Slate 600
      textColor: 255,
      fontStyle: 'bold',
      fontSize: 7,
      halign: 'center',
    },
    didParseCell: hookData => {
      if (hookData.section === 'body') {
        const rowFlags = hookData.row.raw; // This is the array we returned in map()

        if (rowFlags.isGrandTotal) {
          hookData.cell.styles.fillColor = [100, 116, 139]; // Slate 500
          hookData.cell.styles.textColor = 255; // White
          hookData.cell.styles.fontStyle = 'bold';
        } else if (rowFlags.isSummary) {
          hookData.cell.styles.fillColor = [220, 225, 230]; // Clean gray highlight
          hookData.cell.styles.textColor = [30, 41, 59]; // Slate 800
          hookData.cell.styles.fontStyle = 'bold';
        } else if (hookData.row.index % 2 === 0) {
          hookData.cell.styles.fillColor = [248, 250, 252]; // Slate 50
        }
      }
    },
    margin: { left: 10, right: 10 },
  });

  doc.save(fileName);
};
